module.exports = __webpack_public_path__ + "img/duvdevan_no.8766dbf1.png";